module.exports = __webpack_public_path__ + "img/building-hall.85686a0f.jpg";